import * as settings from "./globals";

// Helper functions
function createElement(id, visible, properties){
    const element = document.createElement('DIV');
    element.id = id;
    for(var key in properties){
        element[key] = properties[key];
    }
    element.style.display = (visible)? 'block' : 'none';
    //append element
    document.body.appendChild(element);
    return element;
}

function showElement(id){
    try { document.getElementById(id).style.display = 'block'; } catch(e) {}
}

function hideElement(id){
    try { document.getElementById(id).style.display = 'none'; } catch(e) {}
}

export function addClass(elt, cls){
    elt.className = (elt.className.length > 0)? elt.className + ' ' + cls : cls;
}

export function displayMessage(text){
    const elt = document.getElementById(settings.msgId) || createElement(settings.msgId, true, { className: 'chkMessage' });
    const msg = document.createElement('SPAN');
    msg.innerHTML = typeof text !== 'undefined' ? text : '';
    //append the text to the message container
    elt.innerHTML = '';
    elt.appendChild(msg);
}

export function showModal(id) {
    hideElement(settings.msgId);
    showElement(id);
}

export function hideModal(id) {
    hideElement(id);
    showElement(settings.msgId);
}